import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-sky-900 text-white py-8 font-bungee" aria-label="Footer" role="contentinfo">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-3 gap-8 text-center">
          <div className="flex flex-col space-y-4">
            <a href="https://www.votetexas.gov/" title="Leaving site for VoteTexas.gov" className="hover:underline">VOTETEXAS.GOV</a>
            <a href="mailto:projectvote@sos.texas.gov" className="hover:underline">CONTACT</a>
          </div>
          <div className="flex flex-col space-y-4">
            <a href="https://www.sos.state.tx.us/index.html" className="hover:underline">TEXAS SECRETARY OF STATE</a>
            <a href="https://www.votetexas.gov/get-involved/student-clerks.html" title="Leaving site for student clerks" className="hover:underline">STUDENT WORKERS</a>
          </div>
          <div className="flex flex-col space-y-4">
            <a href="https://www.sos.state.tx.us/privacy.shtml" className="hover:underline">PRIVACY POLICY</a>
            <a href="https://www.sos.state.tx.us/linkpolicy.shtml" className="hover:underline">LINK POLICY</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
